import React, { useEffect, useState } from 'react';
import './Admin.css';
import { Link, useParams } from 'react-router-dom';
import AdminMenu from '../../components/AdminMenu';
import HeaderBottom from '../../components/HomePage/HeaderBottom';
import MarginTop from '../../MarginTop';

const PaymentStatus = () => {
    const [order, setOrder] = useState([]);
    const { id } = useParams();



    useEffect(() => {
        fetch(`https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/order/${id}`)
            .then((res) => res.json())
            .then((info) => setOrder(info));
    }, []);

    // const handlePaymentStatus = (event) => {
    //     event.preventDefault();
    //     const paymentStatus = event.target.paymentStatus.value;

    //     const status = {
    //         paymentStatus,
    //     };

    //     const url = `https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/order/${order._id}`;
    //     fetch(url, {
    //         method: "PUT",
    //         headers: {
    //             "content-type": "application/json",
    //         },
    //         body: JSON.stringify(status),
    //     })
    //         .then((res) => res.json())
    //         .then((result) => {

    //             alert('PaymentStatus is Updated');
    //         });
    // };


    const handleOrderStatus = (event) => {
        event.preventDefault();

        const orderStatus = event.target.orderStatus.value;



        const orderSec = {

            orderStatus,
        };

        const url = `https://seo-for-small-business-01-b3162645ffd8.herokuapp.com/order-status/${order._id}`;
        fetch(url, {
            method: "PUT",
            headers: {
                "content-type": "application/json",
            },
            body: JSON.stringify(orderSec),
        })
            .then((res) => res.json())
            .then((result) => {

                alert('OrderStatus is Updated');
            });
    };

    return (
        <>
            <HeaderBottom></HeaderBottom>
            <MarginTop></MarginTop>
            <div className='container'>
                <section id="services" class="services-area  vh-100">
                    <div class="container">
                        <div class="row"></div>
                        <div class="row justify-content-center">

                            <div className='text-center'> {/* Center-align the content */}
                            

                                <h2 className='mt-5'>Update Order Status</h2>

                                <form onSubmit={handleOrderStatus} className="text-center"> {/* Center-align the form */}
                                    <div class="col-lg-6 mx-auto"> {/* Center-align the select dropdown */}
                                        <div class="contact-field p-relative c-name mb-20">
                                            <select className='form-control' name="orderStatus" id="cars">
                                                <option value="Pending">Pending</option>
                                                <option value="Delivered">Delivered</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="slider-btn">
                                        <button class="btn btn-primary btn-lg mt-2" data-animation="fadeInRight" data-delay=".8s"> Update Order </button>
                                    </div>
                                </form>

                            </div>

                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default PaymentStatus;